import Vue from 'vue';

import './config/breakpointConfig';
import './datepicker';
import './spa/blocks';

import Accordion from '@/core/layout/Accordion.vue';
import ReadMore from '@/core/layout/ReadMore.vue';
import PermissionsValidator from '@/components/dashboard/PermissionsValidator.vue';
import TextWithValue from '@/components/TextWithValue.vue';
import PageSideContainer from '@/components/frontpage/page-side/PageSideContainer.vue';
import PageContainer from '@/components/frontpage/page-content/PageContainer.vue';
import GravatarImg from '@/core/gravatar/GravatarImg.vue';
import Breakpoints from './responsive/Breakpoints.vue';
import ChangelogEntry from '@/components/dashboard/changelogs/ChangelogEntry.vue';
import ChangelogCategorySelector from '@/components/dashboard/changelogs/ChangelogCategorySelector.vue';
import Modal from '@/components/Modal.vue';
import ProfileLink from '@/components/frontpage/profile/ProfileLink.vue';
import CharacterLink from '@/components/frontpage/profile/CharacterLink.vue';
import Interceptor from '@/core/intersection/intersection.observer.vue';
import AnimateValue from '@/components/ui-components/AnimateValue.vue';
import InventoryItem from '@/components/frontpage/armory/items/InventoryItem.vue';
import Directory from '@/components/dashboard/Directory.vue';

Vue.component('Breakpoints', Breakpoints);
Vue.component('accordion', Accordion);
Vue.component('ReadMore', ReadMore);
Vue.component('PermissionsValidator', PermissionsValidator);
Vue.component('TextWithValue', TextWithValue);
Vue.component('PageSideContainer', PageSideContainer);
Vue.component('PageContainer', PageContainer);
Vue.component('Gravatar', GravatarImg);
Vue.component('ChangelogEntry', ChangelogEntry);
Vue.component('ChangelogCategorySelector', ChangelogCategorySelector);
Vue.component('Modal', Modal);
Vue.component('ProfileLink', ProfileLink);
Vue.component('CharacterLink', CharacterLink);
Vue.component('Interceptor', Interceptor);
Vue.component('AnimateValue', AnimateValue);
Vue.component('InventoryItem', InventoryItem);
Vue.component('Directory', Directory);
